<template>
  <div class="repeat">
    <crumb-tit>
      <span
        slot="breadTit"
        v-text="title"
      />
      <span
        slot="secondTit"
        v-text="title"
      />
    </crumb-tit>
    <div
      v-if="!loadingContent"
      class="main"
    >
      <a-alert
        type="warning"
        :message="alertTipTxt"
        show-icon
      />
      <repeat-action
        v-if="showAction"
        :fields="repeatFields"
        :switch-data="switchInfo"
        @change="onChange"
        @switch="switchChange"
      />
    </div>
    <a-spin
      v-if="loadingContent"
      class="spin-style"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import CrumbTit from '@/components/pc/config/CrumbTit'
import RepeatAction from './components/RepeatAction'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    RepeatAction,
    CrumbTit
  },
  data () {
    return {
      switchInfo: {}
    }
  },
  computed: {
    ...mapState('config/repeat', ['repeatFields', 'repeatSwitch', 'loadingContent']),
    ...mapState(['baseinfo', 'menuDatas']),
    showAction () {
      return JSON.stringify(this.switchInfo) !== '{}'
    },
    title () {
      const { title } = this.$route.meta
      return title
    },
    openCloseTxt () {
      return this.$t('message["402"]').split('|')
    },
    alertTipTxt () {
      return this.$t('message["1178"]')
    }
  },
  watch: {
    repeatSwitch: {
      handler (newVal) {
        this.switchInfo = newVal
      },
      immediate: true
    },
    baseinfo (newVal) {
      document.title = this.title + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  created () {
    this.getRepeatSwitchData()
    this.fetchRepeatData()

    this.$bus.$on('fetchRepeatData', this.fetchRepeatData)
  },
  methods: {
    ...mapActions('config/repeat', ['fetchRepeatData', 'getRepeatSwitchData', 'setRepeatSwitchData']),
    ...mapActions(['permissionMenu']),
    ...mapMutations('config/repeat', ['setRepeatSwitch']),

    switchChange (result) {
      // 如果查重功能点击了关闭，，禁止保存和查重白名单页关闭
      let params = this.perpareSitchParams(result)
      // console.log(params)
      this.fetchToSetSwitch(params, 'isrepeat')
    },
    onChange (result, name) {
      if (name === 'isrepeatsave' && result.isrepeatsave === 1 && result.iswhitelist === 1) {
        result.iswhitelist = 0
      }
      this.fetchToSetSwitch(result, name)
    },
    async fetchToSetSwitch (params, name) {
      const { isrepeat, isrepeatsave, iswhitelist } = params
      const _this = this
      const chain = await _this.setRepeatSwitchData(params)
      const { openCloseTxt } = this
      chain.onSuccess(res => {
        _this.setRepeatSwitch(params)
        _this.$message.destroy()
        name === 'isrepeat' && _this.$message.success(isrepeat === 1 ? openCloseTxt[1] : openCloseTxt[0])
        name === 'isrepeatsave' && _this.$message.success(isrepeatsave === 1 ? openCloseTxt[0] : openCloseTxt[1])
        name === 'iswhitelist' && _this.$message.success(iswhitelist === 1 ? openCloseTxt[1] : openCloseTxt[0])
      })
        .onNetComplete(() => {
          name === 'isrepeat' && _this.permissionMenu()
        })
        .fetch()
    },
    perpareSitchParams (params) {
      const { isrepeat, iswhitelist } = params
      if (isrepeat === 0) {
        params.isrepeatsave = 1
      }
      if (iswhitelist === 1) {
        params.iswhitelist = 0
      }
      return params
    }
  }
}
</script>

<style scoped lang="scss">
.main::v-deep {
  margin: 24px 0;
  .ant-alert-warning{
      background: #FFF4E7;
      border: 1px solid #F6A953;
      border-radius: 4px;
    }
}
</style>
<style lang="scss">
.repeat {
  .ant-alert-message {
    margin-left: 14px !important
  }
  .spin-style {
    position: absolute;
    top: 50%;
    left: 50%;
  }
}
</style>
